import { co2 } from './common';

export default {
  'consumption.co2': `Emisiones de ${co2} ciclo mixto`,
  'consumption.energy': 'Consumo de corriente mixto',
  'consumption.fuel': 'Consumo de combustible mixto',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc':
    'Los valores indicados se han determinado según el procedimiento de medición prescrito en el Reglamento [CE] 715/2007 en su versión vigente en la actualidad (Directiva 1999/94/CEE en su versión actual)',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Tu búsqueda / Código online del configurador',
  'search.result.buy-online': 'Compra online',
  'search.results':
    'No se han encontrado resultados | Se ha encontrado 1 resultado | Se han encontrado {count} resultados',
  'search.results.backup': 'No se han encontrado coincidencias. Ver páginas relacionadas:',
  'search.results.count': 'Se han encontrado {count} resultados',
  'search.results.none.summary':
    'No hay resultados disponibles para este término de búsqueda. Intentalo de nuevo con otro término de búsqueda.',
  'search.show-more': 'Mostrar más',
  'search.unavailable': 'La búsqueda no se encuentra disponible en este momento.',
  'search.result.new': 'Nuevo',

  'search.result.consumption': 'Consumo',

  'input.placeholder': 'Tu búsqueda / Código online del configurador',

  'suggestions.all_search_results': 'Todos los resultados de la búsqueda',
  'suggestions.all_search_results_for': 'Mostrar todos los resultados para',
  'suggestions.in': 'en',

  all: 'Todos',
  UCOS: 'Tienda online de vehículos usados',
  PASSENGER_CARS: 'Vehículos',
  VANS: 'Vans',
  NCOS: 'Tienda online de vehículos nuevos',
  VIDEO: 'Videos',
  DEALER_LOCATOR: 'Localizador de concesionarios',
  CONFIGURATOR: 'Configurá tu vehículo',
  TEST_DRIVE: 'Prueba de manejo',
  VEHICLE_SEARCH: 'Buscador de vehículos usados',
  COLLECT: 'Colección y accesorios',
  CONNECT: 'Mercedes me Store',

  'watch.video': 'Vea el vídeo',
  'input.recently': 'Buscado recientemente',
  'input.help.title': '¿Qué puedes buscar?',
  'input.help.text':
    'Puedes realizar búsquedas indicando el tipo de vehículo, el modelo, códigos de configuración o bien buscar accesorios, otros productos e información',

  'search.result.grid': 'Cuadrícula',
  'search.result.list': 'Lista',

  // No results found
  'support.check':
    'Comprueba que no has cometido errores de ortografía, o inténtalo de nuevo con un término diferente.',
  'support.no.results': 'No hay resultados disponibles para este término de búsqueda.',
  'support.no.results.term': 'No se ha encontrado ningún resultado',
  'support.chat': '¿No has encontrado lo que estabas buscando? Acude a nuestro servicio de asistencia por',
  'support.chat.with.us': 'conversación online',
};
